import {
  IconClipboardCheck,
  IconLock,
  IconFileCertificate,
  IconBuildingWarehouse,
  IconChartBar,
} from '@tabler/icons-react';

// Screenshots live in src/assets/login-slides. The shell falls back to the
// brand colour for any slide without one, so these can be added later.
let slide1, slide2, slide3, slide4, slide5;
try { slide1 = require('../../assets/login-slides/slide-1.jpg'); } catch (e) {}
try { slide2 = require('../../assets/login-slides/slide-2.jpg'); } catch (e) {}
try { slide3 = require('../../assets/login-slides/slide-3.jpg'); } catch (e) {}
try { slide4 = require('../../assets/login-slides/slide-4.jpg'); } catch (e) {}
try { slide5 = require('../../assets/login-slides/slide-5.jpg'); } catch (e) {}

export const PRODUCT_LABEL = 'OPERATIONS';

export const slides = [
  {
    icon: IconClipboardCheck,
    image: slide1,
    title: 'Every machine checked. Every morning. Signed.',
    body: 'Operators work through the check on their phone before they start. Each result is timestamped against a named person, so what happened is never in question.',
    stats: [{ val: '412', lbl: 'Checks recorded' }, { val: '96%', lbl: 'Pass rate' }],
  },
  {
    icon: IconLock,
    image: slide2,
    title: 'A machine that fails a check stops.',
    body: 'A critical defect blocks the machine outright. It goes back to work when a manager writes the release — what was found, what was done, how it was checked. Their name is on it.',
    stats: [{ val: '2', lbl: 'Machines blocked' }, { val: '6 days', lbl: 'Average downtime' }],
  },
  {
    icon: IconFileCertificate,
    image: slide3,
    title: 'A machine record a buyer can actually verify.',
    body: 'Issue a passport for any machine — identity, hours, service history, every release statement. The recipient scans the code and confirms it came from you, unaltered.',
    stats: [{ val: '1', lbl: 'Scan to verify' }, { val: '100%', lbl: 'Traceable' }],
  },
  {
    icon: IconBuildingWarehouse,
    image: slide4,
    title: "Your dealer's work, on your machine's record.",
    body: 'Connect a workshop and their sealed job cards arrive automatically — parts, photos, video and cost, against the right machine. No paperwork to chase.',
    stats: [{ val: 'Live', lbl: 'Job status' }, { val: '0', lbl: 'Forms to file' }],
  },
  {
    icon: IconChartBar,
    image: slide5,
    title: 'The whole fleet, honestly.',
    body: 'Hours, compliance dates, defect history and cost of ownership across every machine and site — current, not a snapshot someone typed up last month.',
    stats: [{ val: '10', lbl: 'Machines' }, { val: '4', lbl: 'Sites' }],
  },
];
